import * as Yup from "yup";
import {
  cepRequired,
  cpf,
  email,
  name,
  phone,
  term_of_contract,
} from "../YupSchema";

export const validationBuyNow = Yup.object().shape({
  user: Yup.object().shape({
    name: name,
    document_nr: cpf,
    email: email,
    cell_phone: phone,
    term_of_contract: term_of_contract,
  }),
  payment_owner: Yup.object().shape({
    name: name,
    document_nr: cpf,
    email: email,
    address: Yup.object().shape({
      zip_code: cepRequired,
      city: Yup.string().required("global.schemas.city.required"),
      state: Yup.string().required("global.schemas.state.required"),
      additional_details: Yup.string().nullable(),
      country: Yup.string().required("global.schemas.country.required"),
      number: Yup.string().required("global.schemas.number_cep.required"),
      street: Yup.string().required("global.schemas.street.required"),
      neighborhood: Yup.string().required(
        "global.schemas.neighborhood.required"
      ),
    }),
  }),
  payment_info: Yup.object().when(["planHasPrice"], {
    is: (plan: boolean) => !!plan,
    then: (value) => value.nullable(),
    otherwise: (value) =>
      value.shape({
        issuer: Yup.string().required("global.schemas.issuer.required"),
        number: Yup.string().required("global.schemas.number_card.required"),
        name: Yup.string().required("global.schemas.name_card.required"),
        maturity: Yup.string().required("global.schemas.maturity.required"),
        cvv: Yup.number().required("global.schemas.cvv.required"),
      }),
  }),
  planHasPrice: Yup.boolean(),
  term_of_product: Yup.boolean().required(
    "global.schemas.term_of_product.required"
  ),
  plan_id: Yup.string().test(
    "validate-plans",
    "global.schemas.validate_plans.required",
    (value) => !!value
  ),
});
